import { IUnsavedChangesContext } from '@contexts-clean/unsaved-changes-context';

export type UnsavedChangesArea =
    'general' | 'central-monitoring-toolkit' | 'subject-monitoring-toolkit' | 'risk-assessment-toolkit';

type GetUnsavedChangesFunctionForAreaReturn = {
    hasChanges: (key: string) => boolean;
    setChanges: (key: string, value: boolean) => void;
    hasAnyChanges: () => boolean;
    clearAllChanges: () => void;
};

// Gets the functions for the interacting with an unsaved changes map based on `area`
export function getUnsavedChangesFunctionsForArea(
    context: IUnsavedChangesContext,
    area: UnsavedChangesArea,
): GetUnsavedChangesFunctionForAreaReturn {
    switch (area) {
        case 'general':
            return {
                hasChanges: context.componentHasChanges,
                setChanges: context.setComponentHasChanges,
                hasAnyChanges: context.anyComponentHasChanges,
                clearAllChanges: context.discardChanges,
            };
        case 'central-monitoring-toolkit':
            return {
                hasChanges: context.centralMonitoringToolkitHasChanges,
                setChanges: context.setCentralMonitoringToolkitHasChanges,
                hasAnyChanges: context.anyCentralMonitoringToolkitHasChanges,
                clearAllChanges: context.centralMonitoringToolkitDiscardChanges,
            };
        case 'subject-monitoring-toolkit':
            return {
                hasChanges: context.subjectMonitoringToolkitHasChanges,
                setChanges: context.setSubjectMonitoringToolkitHasChanges,
                hasAnyChanges: context.anySubjectMonitoringToolkitHasChanges,
                clearAllChanges: context.subjectMonitoringToolkitDiscardChanges,
            };
        case 'risk-assessment-toolkit':
            return {
                hasChanges: context.riskAssessmentToolkitHasChanges,
                setChanges: context.setRiskAssessmentToolkitHasChanges,
                hasAnyChanges: context.anyRiskAssessmentToolkitHasChanges,
                clearAllChanges: context.riskAssessmentToolkitDiscardChanges,
            };
        default:
            throw new Error(`Unknown UnsavedChangesArea: '${area}'`);
    }
}
